import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { UniDaysComponent } from './third-party/UniDays/unidays.component';
import { SubscribeToNewsletterComponent } from './my-greyhound/subscribe-to-newsletter/subscribe-to-newsletter.component';

const routes: Routes = [
    // { path: '', redirectTo: '/', pathMatch: 'full' },
    {
        path: '',
        loadChildren: 'app/home/home.module#HomeModule',
    },
    // These two routes are created by the umbraco urlrewriting.config system
    { path: 'coach-travel/make-a-booking', redirectTo: 'book-a-trip', pathMatch: 'full' },
    { path: 'coach-travel/make-a-booking/:context', redirectTo: 'book-a-trip', pathMatch: 'full' },
    { path: 'book-a-ticket', redirectTo: 'book-a-trip', pathMatch: 'full' },
    { path: 'manage-booking', redirectTo: 'manage-booking', pathMatch: 'full' },
    { path: 'my-greyhound/manage-booking', redirectTo: 'manage-booking', pathMatch: 'full' },
    { path: 'my-greyhound/manage-booking/:context', redirectTo: 'manage-booking', pathMatch: 'full' },
    {
        path: 'my-greyhound',
        loadChildren: 'app/my-greyhound/my-greyhound.module#MyGreyhoundModule',
    },
    {
        path: 'my-experience',
        loadChildren: 'app/my-experience/my-experience.module#MyExperienceModule',
    },
    {
        path: 'packages',
        loadChildren: 'app/travel-products/travel-products.module#TravelProductsModule',
    },
    {
        path: 'experiences',
        loadChildren: 'app/travel-products/travel-products.module#TravelProductsModule',
    },
    {
        path: 'accommodation',
        loadChildren: 'app/travel-products/travel-products.module#TravelProductsModule',
    },
    {
        path: 'coach-travel',
        loadChildren: 'app/travel-products/travel-products.module#TravelProductsModule',
    },
    {
        path: 'book-a-ticket',
        loadChildren: 'app/travel-products/travel-products.module#TravelProductsModule',
    },
    {
        path: 'information',
        loadChildren: 'app/information/information.module#InformationModule'
    },
    {
        path: 'newsletter',
        loadChildren: 'app/my-greyhound/newsletter.module#NewsletterModule'
    },
    {
        path: 'newsletter-b',
        loadChildren: 'app/my-greyhound/newsletter.module#NewsletterModule'
    },
    {
        path: 'travel-information',
        loadChildren: 'app/information/information.module#InformationModule'
    },
    {
        path: 'contact-us',
        loadChildren: 'app/contact-us/contact-us.module#ContactUsModule'
    },
    {
        path: 'unidays',
        component: UniDaysComponent,
    }
];

@NgModule({
    imports: [RouterModule.forRoot(routes)],
    exports: [RouterModule],
    declarations: [
        UniDaysComponent
    ]
})
export class AppRoutingModule { }



// WEBPACK FOOTER //
// ./src/app/app-routing.module.ts